export default __webpack_public_path__ + "ec4138a133fe761efd6583f8a35e7538.svg";